/* Machino 6th Anniversary Roadshow — drives the van, stop bubbles and confetti. Config comes from the section's JSON block.
   Poster style (Oct 2026): cream paper, one thin dashed road, pastel outlined desserts, uppercase labels under each stop. */
(function () {
  function init(root) {
  var cfgEl = root.querySelector("[data-roadshow-config]"); if (!cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var STOPS = (cfg.stops || []).map(function (s) { return { name: s.name || "", place: s.place || "", kind: s.kind || "cafe", start: (s.start || "").trim(), end: (s.end || "").trim(), time: s.time || "", map: s.map || "" }; });
  var W = 600, H = 760;
  var SLOTS = [{ x: 470, y: 180 }, { x: 170, y: 410 }, { x: 430, y: 600 }];
  var START = { name: cfg.office || "Machino Office", x: 185, y: 100 };
  var useConfetti = cfg.confetti === true, scrollStart = cfg.scrollStart === true;
  var TZ = cfg.tz || "Asia/Kuala_Lumpur", PREVIEW = cfg.preview || "";
  var WORDMARK = cfg.wordmark || "";
  var SVGNS = "http://www.w3.org/2000/svg";
  var B = "var(--mr-line)", SK = ' stroke="' + B + '" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"', SK1 = ' fill="none" stroke="' + B + '" stroke-width="1.5" stroke-linecap="round"';
  var q = function (s) { return root.querySelector(s); };
  var svg = q("[data-svg]"), route = q("[data-route]"), car = q("[data-car]"), carFlip = q("[data-carflip]"), carLabel = q("[data-carlabel]"), fx = q("[data-fx]"), scene = q("[data-scene]");
  var total = route.getTotalLength();
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function el(tag, attrs, html) { var e = document.createElementNS(SVGNS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (html) e.innerHTML = html; return e; }
  function day(s) { var p = (s || "").split("-"); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function ord(n) { var r = n % 100; if (r >= 11 && r <= 13) return "th"; return ["th", "st", "nd", "rd"][n % 10] || "th"; }
  function mon(ms) { return new Date(ms).toLocaleDateString("en-MY", { month: "short", timeZone: "UTC" }); }
  function fmt(ms) { var d = new Date(ms).getUTCDate(); return d + ord(d) + " " + mon(ms); }
  function fmtHtml(ms) { var d = new Date(ms).getUTCDate(); return d + "<sup>" + ord(d) + "</sup> " + mon(ms); }
  function range(st) { return fmt(day(st.start)) + " – " + fmt(day(st.end)); }
  function rangeHtml(st) { return fmtHtml(day(st.start)) + " – " + fmtHtml(day(st.end)); }
  function wazeUrl(st) { return "https://waze.com/ul?q=" + encodeURIComponent(st.map) + "&navigate=yes"; }
  function gmapUrl(st) { return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(st.map); }
  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  function todayKey() {
    if (PREVIEW && /^\d{4}-\d{2}-\d{2}$/.test(PREVIEW)) return PREVIEW;
    try { return new Date().toLocaleDateString("en-CA", { timeZone: TZ }); } catch (e) { return new Date().toISOString().slice(0, 10); }
  }

  STOPS = STOPS.filter(function (s) { return s.name && s.start && s.end; }).slice(0, 3);
  STOPS.forEach(function (s, i) { s.x = SLOTS[i].x; s.y = SLOTS[i].y; });

  // ---- drawings (all sit on baseline y=0, centred on x=0) ----
  var C = { pan1: "#f3cfa0", pan2: "#f8dfbb", syrup: "#e9b25f", butter: "#fbe68a", glass: "#cfe3ee", door: "#d98f6a", wall: "#f6d9c7", waffle: "#f0c88e", grid: "#c9985a", cream: "#fbe9c8", pink: "#f4b9b8", cherry: "#d9484e", flame: "#f3c24d", puff: "#dcebf3", awning: "#f2c4c0", shop: "#fff7e6" };
  function puff(x, y, s) { return '<g transform="translate(' + x + ',' + y + ') scale(' + (s || 1) + ')"><path d="M-16 4 C-25 4 -25 -8 -15 -9 C-15 -20 2 -22 7 -12 C17 -16 24 -3 13 4 Z" fill="' + C.puff + '"' + SK + '/></g>'; }
  function drips(x1, x2, y, step, c) { var d = 'M' + x1 + ' ' + (y - 6) + ' H' + x2 + ' V' + y, x = x2; while (x - step >= x1 - 0.01) { d += ' q-' + (step / 2) + ' 12 -' + step + ' 0'; x -= step; } d += ' L' + x1 + ' ' + y + ' Z'; return '<path d="' + d + '" fill="' + c + '"' + SK + '/>'; }
  function arch(x, w, h, c) { var r = w / 2; return '<path d="M' + x + ' 0 V' + (-(h - r)) + ' a' + r + ' ' + r + ' 0 0 1 ' + w + ' 0 V0 Z" fill="' + c + '"' + SK + '/><circle cx="' + (x + w - 5) + '" cy="' + (-(h / 2) + 2) + '" r="1.6" fill="' + B + '"/>'; }
  function win(x, y, w, h) { return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="' + C.glass + '"' + SK + '/><path d="M' + (x + w / 2) + ' ' + y + ' V' + (y + h) + ' M' + x + ' ' + (y + h / 2) + ' H' + (x + w) + '"' + SK1 + '/>'; }
  function rwin(x, y, r) { return '<circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="' + C.glass + '"' + SK + '/><path d="M' + x + ' ' + (y - r) + ' V' + (y + r) + ' M' + (x - r) + ' ' + y + ' H' + (x + r) + '"' + SK1 + '/>'; }
  function dots(pts, c, r) { return pts.map(function (p) { return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + (r || 2.2) + '" fill="' + c + '"/>'; }).join(''); }
  function pancake() {
    return '<rect x="-70" y="-40" width="140" height="40" rx="20" fill="' + C.pan1 + '"' + SK + '/>' +
      '<rect x="-66" y="-74" width="132" height="38" rx="19" fill="' + C.pan2 + '"' + SK + '/>' + drips(-60, 60, -68, 15, C.syrup) +
      '<rect x="-62" y="-106" width="124" height="36" rx="18" fill="' + C.pan1 + '"' + SK + '/>' + drips(-56, 56, -100, 14, C.syrup) +
      '<rect x="-14" y="-118" width="28" height="14" rx="3" fill="' + C.butter + '"' + SK + '/>' +
      arch(-14, 28, 30, C.door) + win(-52, -27, 18, 14) + win(34, -27, 18, 14) + rwin(0, -55, 8) + win(-30, -96, 14, 12) + win(16, -96, 14, 12) +
      puff(-46, -132, 1) + puff(-20, -146, .75) + puff(40, -138, .85);
  }
  function waffle() {
    var g = '', y, x, hw;
    for (y = -124; y <= -80; y += 11) { hw = (y + 134) * 74 / 62 - 4; g += 'M' + (-hw) + ' ' + y + ' H' + hw + ' '; }
    for (x = -48; x <= 48; x += 12) { var ty = -134 + Math.abs(x) * 62 / 74 + 4; g += 'M' + x + ' ' + ty + ' V-74 '; }
    return '<rect x="-58" y="-72" width="116" height="72" rx="3" fill="' + C.wall + '"' + SK + '/>' +
      '<rect x="28" y="-124" width="12" height="18" rx="2" fill="' + C.door + '"' + SK + '/>' +
      '<path d="M-74 -72 L0 -134 L74 -72 Z" fill="' + C.waffle + '"' + SK + '/>' +
      '<path d="' + g + '" fill="none" stroke="' + C.grid + '" stroke-width="2" stroke-linecap="round"/>' +
      rwin(0, -98, 9) + arch(-34, 24, 32, C.door) + win(12, -52, 28, 22) +
      '<g fill="' + C.glass + '"' + SK + '><circle cx="-66" cy="-8" r="10"/><circle cx="-54" cy="-13" r="13"/><circle cx="-44" cy="-6" r="8"/><circle cx="66" cy="-8" r="10"/><circle cx="54" cy="-13" r="13"/><circle cx="44" cy="-6" r="8"/></g>' +
      puff(34, -138, .8);
  }
  function cake() {
    return '<rect x="-72" y="-44" width="144" height="44" rx="6" fill="' + C.cream + '"' + SK + '/>' + drips(-72, 72, -38, 16, C.pink) +
      '<rect x="-52" y="-84" width="104" height="40" rx="6" fill="' + C.cream + '"' + SK + '/>' + drips(-52, 52, -78, 14.86, C.pink) +
      '<rect x="-32" y="-118" width="64" height="34" rx="5" fill="' + C.cream + '"' + SK + '/>' + drips(-32, 32, -112, 16, C.pink) +
      '<rect x="-4" y="-140" width="8" height="22" fill="#fff"' + SK + '/><path d="M-4 -134 h8 M-4 -126 h8" stroke="' + C.pink + '" stroke-width="2.5"/>' +
      '<ellipse cx="0" cy="-149" rx="4" ry="7" fill="' + C.flame + '"' + SK + '/><ellipse cx="0" cy="-147" rx="1.6" ry="3" fill="#fff3c4"/>' +
      arch(-12, 24, 26, C.door) + win(-56, -28, 16, 14) + win(40, -28, 16, 14) + win(-38, -66, 14, 12) + win(24, -66, 14, 12) +
      '<g fill="' + C.cherry + '"' + SK + '><circle cx="-62" cy="-49" r="5"/><circle cx="62" cy="-49" r="5"/><circle cx="-42" cy="-89" r="5"/><circle cx="42" cy="-89" r="5"/></g>' +
      dots([[-32, -12], [30, -14], [-10, -34], [14, -32], [-24, -58], [20, -60], [-12, -98], [12, -100]], C.pink) +
      puff(-84, -96, .8) + puff(84, -70, .7);
  }
  function shop(sign) {
    return '<rect x="-40" y="-56" width="80" height="56" rx="3" fill="' + C.shop + '"' + SK + '/>' +
      '<rect x="-44" y="-62" width="88" height="7" rx="2" fill="' + C.door + '"' + SK + '/>' +
      '<rect x="-34" y="-53" width="68" height="12" rx="2" fill="#fff"' + SK + '/>' + sign +
      drips(-46, 46, -34, 13.14, C.awning) +
      arch(-10, 20, 20, C.door) + win(-34, -24, 16, 13) + win(18, -24, 16, 13);
  }
  function building(kind) {
    if (kind === "pancake") return pancake();
    if (kind === "waffle") return waffle();
    if (kind === "cake") return cake();
    if (kind === "office") return shop(WORDMARK ? '<image href="' + WORDMARK + '" x="-30" y="-52" width="60" height="10" preserveAspectRatio="xMidYMid meet"/>' : '<text x="0" y="-44" text-anchor="middle" font-family="inherit" font-weight="700" font-size="8" fill="' + B + '" letter-spacing="1.5">MACHINO</text>');
    return shop('<text x="0" y="-44" text-anchor="middle" font-family="inherit" font-weight="700" font-size="8" fill="' + B + '" letter-spacing="1.5">CAFÉ</text>');
  }
  var HEIGHTS = { pancake: 150, waffle: 142, cake: 158, office: 64, cafe: 64 };

  // nearest road point for each stop
  STOPS.forEach(function (s) {
    var best = 0, bestD = Infinity;
    for (var L = 0; L <= total; L += 2) { var p = route.getPointAtLength(L), d = (p.x - s.x) * (p.x - s.x) + (p.y - s.y) * (p.y - s.y); if (d < bestD) { bestD = d; best = L; } }
    s.len = best; var pt = route.getPointAtLength(best); s.rx = pt.x; s.ry = pt.y;
    s.park = Math.max(0, best - 140); // park just before the building so the van never covers it
  });

  // ---- buildings on the map + HTML labels under them ----
  var layer = q("[data-stops]");
  var labels = document.createElement("div"); labels.className = "mr-labels"; scene.appendChild(labels);
  STOPS.forEach(function (s, i) {
    var kind = HEIGHTS[s.kind] ? s.kind : "cafe", by = s.ry + 3;
    var g = el("g", { class: "mr-stop", transform: "translate(" + s.rx + "," + by + ")", tabindex: "0", role: "button", "aria-label": "Details for " + s.name });
    g.innerHTML = '<g class="inner"><ellipse class="glow" cx="0" cy="-2" rx="96" ry="14"/>' + building(kind) + '</g>';
    g.addEventListener("click", function (e) { e.stopPropagation(); openBubble(i); });
    g.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openBubble(i); } });
    layer.appendChild(g); s.node = g; s.topY = by - HEIGHTS[kind];
    var lb = document.createElement("button"); lb.type = "button"; lb.className = "mr-lbl";
    lb.style.left = (s.rx / W * 100) + "%"; lb.style.top = ((by + 12) / H * 100) + "%";
    lb.innerHTML = '<b>' + rangeHtml(s) + '</b><span>' + esc(s.time) + '</span><em>' + esc(s.place || s.name) + '</em>';
    lb.addEventListener("click", function (e) { e.stopPropagation(); openBubble(i); });
    labels.appendChild(lb); s.label = lb;
  });
  (function () {
    var g = el("g", { transform: "translate(" + START.x + "," + START.y + ")" });
    g.innerHTML = building("office");
    layer.appendChild(g);
    var lb = document.createElement("div"); lb.className = "mr-lbl mr-lbl--office";
    lb.style.left = (START.x / W * 100) + "%"; lb.style.top = ((START.y + 8) / H * 100) + "%";
    lb.innerHTML = '<em>' + esc(START.name) + '</em>'; labels.appendChild(lb);
  })();
  function clampLabels() {
    var sc = scene.getBoundingClientRect();
    Array.prototype.forEach.call(labels.children, function (lb) {
      lb.style.marginLeft = "0px";
      var r = lb.getBoundingClientRect(), shift = 0;
      if (r.left < sc.left + 6) shift = sc.left + 6 - r.left;
      else if (r.right > sc.right - 6) shift = sc.right - 6 - r.right;
      if (shift) lb.style.marginLeft = shift + "px";
    });
  }
  clampLabels();

  // ---- bubble ----
  var bubble = q("[data-bubble]"), openIdx = null;
  function openBubble(i) {
    var s = STOPS[i]; openIdx = i;
    q("[data-b-name]").textContent = s.name; q("[data-b-place]").textContent = s.place; q("[data-b-dates]").textContent = range(s); q("[data-b-time]").textContent = s.time;
    q("[data-b-waze]").href = wazeUrl(s); q("[data-b-gmap]").href = gmapUrl(s);
    bubble.hidden = false; placeBubble(); sparkle(s.rx, s.topY);
  }
  function placeBubble() {
    if (bubble.hidden || openIdx === null) return;
    var s = STOPS[openIdx], rct = svg.getBoundingClientRect(), k = rct.width / W;
    var ax = s.rx * k, ay = s.topY * k - 10, w = bubble.offsetWidth, h = bubble.offsetHeight;
    var left = Math.max(8, Math.min(rct.width - w - 8, ax - w / 2)), top = ay - h - 14, below = top < 8;
    if (below) { var lr = s.label.getBoundingClientRect(); top = lr.bottom - rct.top + 14; }
    bubble.classList.toggle("below", below);
    bubble.style.left = left + "px"; bubble.style.top = top + "px";
    bubble.style.setProperty("--tail", Math.max(18, Math.min(w - 18, ax - left)) + "px");
  }
  function closeBubble() { bubble.hidden = true; openIdx = null; }
  q("[data-bubble-close]").addEventListener("click", closeBubble);
  document.addEventListener("click", function (e) { if (!bubble.hidden && !bubble.contains(e.target)) closeBubble(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeBubble(); });
  window.addEventListener("resize", function () { clampLabels(); placeBubble(); });

  // ---- van ----
  var curLen = 0, anim = null, driving = false, lastPuff = 0, started = false, travelDir = 1;
  function placeCar(L) {
    var p = route.getPointAtLength(L), a = route.getPointAtLength(Math.max(0, L - 2)), b = route.getPointAtLength(Math.min(total, L + 2));
    var dx = (b.x - a.x) * travelDir, dy = (b.y - a.y) * travelDir, ang = Math.atan2(dy, dx) * 180 / Math.PI;
    car.setAttribute("transform", "translate(" + p.x + "," + (p.y + 2) + ") rotate(" + ang + ")");
    carFlip.setAttribute("transform", dx < 0 ? "scale(1,-1)" : "");
    if (carLabel) carLabel.setAttribute("transform", dx < 0 ? "translate(66,0) scale(-1,1)" : "");
    if (driving && performance.now() - lastPuff > 110) {
      lastPuff = performance.now();
      var pq = route.getPointAtLength(Math.max(0, Math.min(total, L - 44 * travelDir)));
      var c = el("circle", { cx: pq.x, cy: pq.y + 4, r: 5, fill: C.puff, stroke: B, "stroke-width": 1.2, class: "mr-puff", style: "transform-box:fill-box;transform-origin:center" });
      fx.appendChild(c); setTimeout(function () { c.remove(); }, 750);
    }
  }
  function driveTo(L, cb) {
    if (anim) cancelAnimationFrame(anim);
    if (reduceMotion) { curLen = L; placeCar(L); if (cb) cb(); return; }
    var from = curLen, dist = Math.abs(L - from), dur = Math.min(3600, 500 + dist * 2.4), t0 = performance.now(), dir = L >= from ? 1 : -1;
    driving = dist > 1; svg.classList.toggle("driving", driving); if (driving) travelDir = dir;
    (function step(t) {
      var k = Math.min(1, (t - t0) / dur); k = k < .5 ? 2 * k * k : -1 + (4 - 2 * k) * k;
      curLen = from + (L - from) * k; placeCar(curLen);
      if (k < 1) { anim = requestAnimationFrame(step); } else { driving = false; svg.classList.remove("driving"); if (cb) cb(); }
    })(t0);
  }
  function target(now) {
    if (!STOPS.length) return { len: 0, state: "none", idx: 0 };
    var first = STOPS[0], last = STOPS[STOPS.length - 1];
    if (now < day(first.start)) return { len: 0, state: "before", idx: 0 };
    if (now > day(last.end)) return { len: 0, state: "after", idx: STOPS.length - 1 };
    for (var i = 0; i < STOPS.length; i++) {
      var s = STOPS[i], n = STOPS[i + 1];
      if (now >= day(s.start) && now <= day(s.end)) return { len: s.park, state: "at", idx: i };
      if (n && now > day(s.end) && now < day(n.start)) return { len: s.park + (n.park - s.park) * ((now - day(s.end)) / (day(n.start) - day(s.end))), state: "between", idx: i + 1 };
    }
    return { len: 0, state: "before", idx: 0 };
  }

  var NOW = day(todayKey()), title = q("[data-status-title]"), sub = q("[data-status-sub]");
  function render() {
    var tg = target(NOW), s = STOPS[tg.idx];
    if (started) driveTo(tg.len);
    if (title && sub) {
      if (tg.state === "none") { title.textContent = START.name; sub.textContent = "Add stops to this section to start the tour."; }
      if (tg.state === "before") { title.textContent = "Parked at " + START.name; sub.textContent = "First stop " + s.name + " · " + range(s); }
      if (tg.state === "at") { title.textContent = "We're here now! " + s.name; sub.textContent = s.place + " · until " + fmt(day(s.end)) + " · " + s.time; }
      if (tg.state === "between") { title.textContent = "On the way to " + s.name; sub.textContent = s.place + " · arriving " + fmt(day(s.start)); }
      if (tg.state === "after") { title.textContent = "Back home at " + START.name + ". Thank you! 🎉"; sub.textContent = "See you at our stores any day."; }
    }
    var chips = q("[data-chips]"), made = [], live = null;
    if (chips) chips.innerHTML = "";
    STOPS.forEach(function (st, i) {
      var state = "";
      if (NOW > day(st.end)) state = "done"; else if (NOW >= day(st.start)) state = "now";
      ["now", "done"].forEach(function (c) { st.node.classList.toggle(c, state === c); st.label.classList.toggle(c, state === c); });
      if (chips) {
        var c = document.createElement("button"); c.type = "button"; c.className = "mr-chip" + (state ? " " + state : "");
        c.innerHTML = '<i></i>' + esc(st.name) + ' <small>' + rangeHtml(st) + '</small>';
        c.addEventListener("click", function (e) { e.stopPropagation(); openBubble(i); });
        if (state === "now" && live === null) live = c; else made.push(c);
      }
    });
    // the stop that is on right now goes first in the row (matters on phones, where the row scrolls); order is back to normal once it ends
    if (chips) { if (live) chips.appendChild(live); made.forEach(function (c) { chips.appendChild(c); }); }
  }
  function startEngine() { if (started) return; started = true; driveTo(target(NOW).len); }
  placeCar(0); curLen = 0; render();
  if (scrollStart && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries, obs) { if (entries.some(function (e) { return e.isIntersecting; })) { startEngine(); obs.disconnect(); } }, { threshold: 0.35 }).observe(scene);
  } else { startEngine(); }

  // ---- sparkles + confetti ----
  function sparkle(x, y) {
    for (var k = 0; k < 6; k++) {
      var t = el("text", { x: x + (Math.random() * 140 - 70), y: y + (Math.random() * 20), "font-size": 14 + Math.random() * 10, class: "mr-heart", style: "transform-box:fill-box" });
      t.textContent = ["✨", "💗", "✨"][k % 3]; fx.appendChild(t); setTimeout(function (n) { n.remove(); }, 1200, t);
    }
  }
  var RAINBOW = ['#ff4d6d', '#ffb703', '#3a86ff', '#06d6a0', '#8338ec', '#fb5607', '#ff8fab'], fire = null;
  function celebrate() {
    car.classList.remove("honk"); void car.offsetWidth; car.classList.add("honk");
    var p = route.getPointAtLength(curLen), ch = 76;
    try { ch = Math.max(76, car.getBBox().height + 18); } catch (e) {}
    var g = el("g", { transform: "translate(" + (p.x + 10) + "," + (p.y - ch) + ")" });
    g.innerHTML = '<g class="mr-beep" style="transform-box:fill-box"><rect x="-60" y="-16" width="120" height="30" rx="15" fill="#fffdf7"' + SK + '/><path d="M-6 14 L0 24 L6 14 Z" fill="#fffdf7"' + SK + '/><text x="0" y="5" text-anchor="middle" font-family="inherit" font-weight="700" font-size="13" letter-spacing="1" fill="var(--mr-accent)">HAPPY 6TH! 🎂</text></g>';
    fx.appendChild(g); setTimeout(function () { g.remove(); }, 1200);
    if (!useConfetti || reduceMotion || !window.confetti) return;
    if (!fire) fire = window.confetti.create(q("[data-confetti-canvas]"), { resize: true, useWorker: false });
    var rc = car.getBoundingClientRect(), ox = (rc.left + rc.width / 2) / window.innerWidth, oy = (rc.top + rc.height / 2) / window.innerHeight;
    fire({ particleCount: 120, spread: 80, startVelocity: 45, origin: { x: ox, y: oy }, colors: RAINBOW, ticks: 220, scalar: 1.05 });
    setTimeout(function () {
      fire({ particleCount: 60, angle: 60, spread: 55, startVelocity: 50, origin: { x: 0, y: 0.8 }, colors: RAINBOW, ticks: 200 });
      fire({ particleCount: 60, angle: 120, spread: 55, startVelocity: 50, origin: { x: 1, y: 0.8 }, colors: RAINBOW, ticks: 200 });
    }, 200);
  }
  car.addEventListener("click", function (e) { e.stopPropagation(); celebrate(); });
  car.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); celebrate(); } });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll(".mr-root"), function (r) { if (!r.dataset.roadshowReady) { r.dataset.roadshowReady = "1"; init(r); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
